import React from 'react';
import { Stack } from '../Stack/Stack';
import { t } from '../../locales/translate';
import { FormSelect } from '../Form/Select/FormSelect';
import { Paginator } from '../../model/data';
import { rowsPerPageOptions } from '../cursor_pagination/cursor_pagination';
import { Button } from '../Button/Button';

interface PaginatorProps {
  paginator: Paginator;
}

export function LoadMorePagination({ paginator }: PaginatorProps): JSX.Element {
  const maxPages = Math.ceil(paginator.totalCount / paginator.perPage);
  const hasNextPage = paginator.page + 1 < maxPages;

  return (
    <Stack line size="lg">
      <Stack line size="xs">
        <p>{t.general.rowsPerPage}</p>
        <FormSelect
          options={rowsPerPageOptions}
          value={String(paginator.perPage)}
          compact
          widthAuto
          onChange={(value) => {
            if (value) paginator.setPerPage(Number(value));
          }}
        />
      </Stack>
      {hasNextPage && <Button title={t.actions.loadMore} onClick={() => paginator.setPage(paginator.page + 1)} />}
    </Stack>
  );
}
